import { rules } from './rules';

export const validator = {
  rules,
  std_form_error: 'Validation error, check the form.'
};
